import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { VehicleDetails, VehicleFullDetails } from './vehicle-details.model';

interface GlassGuideSimpleSearchVehicle {
  YEAR: string;
  MAKE: string;
  FAMILY: string;
}

export interface GlassGuideSearchVehicle {
  CODE: string;
  NVIC_KEY: string;
  NVIC: string;
  YEAR: string;
  MTH: string;
  MAKE: string;
  FAMILY: string;
  VARIANT: string;
  SERIES: string;
  STYLE: string;
  DRIVE: string;
  ENGINE: string;
  VALVE: string;
  NO_OF_VALVES: string;
  CC: string;
  SIZE: string;
  TRANSMISSION: string;
  CYL: string;
  WIDTH: string;
  NEW_PR: string;
  ABOVE_AVERAGE_PR: string;
  AVERAGE_PR: string;
  BELOW_AVERAGE_PRICE: string;
}

interface GlassGuideSimpleSearchResponse<T> {
  '@data.context': string;
  '@data.count': number;
  value: T[] & {
    '@search.score': number;
  };
}

export interface VehicleDetailsServiceOptions {
  glassGuideApiBaseUrl: string;
  glassGuideApiKey: string;
}

@Injectable()
export class VehicleDetailsService {
  constructor(
    private http: HttpClient,
    @Inject('options') private options: VehicleDetailsServiceOptions
  ) {}

  simpleSearch(query: string): Observable<VehicleDetails[]> {
    return this.http
      .post<GlassGuideSimpleSearchResponse<GlassGuideSimpleSearchVehicle>>(
        `${this.options.glassGuideApiBaseUrl}indexes/motglass-simplesearch-index/docs/search?api-version=2016-09-01`,
        {
          count: true,
          skip: 0,
          top: 20,
          searchMode: 'any',
          queryType: 'simple',
          filter: "TYPE eq 'MOTOR'",
          search: query
        },
        {
          headers: {
            'api-key': this.options.glassGuideApiKey
          }
        }
      )
      .pipe(
        map((x) => {
          return x.value.map((v) => {
            return {
              make: v.MAKE,
              model: v.FAMILY,
              year: +v.YEAR
            };
          });
        })
      );
  }

  search(query: string): Observable<VehicleFullDetails[]> {
    return this.http
      .post<GlassGuideSimpleSearchResponse<GlassGuideSearchVehicle>>(
        `${this.options.glassGuideApiBaseUrl}indexes/motglass-search-index/docs/search?api-version=2016-09-01`,
        {
          count: true,
          skip: 0,
          top: 20,
          searchMode: 'any',
          queryType: 'simple',
          filter: "TYPE eq 'MOTOR'",
          search: query
        },
        {
          headers: {
            'api-key': this.options.glassGuideApiKey
          }
        }
      )
      .pipe(
        map((x) => {
          return x.value.map((v) => {
            return {
              make: v.MAKE,
              model: v.FAMILY,
              year: +v.YEAR,
              variant: v.VARIANT,
              nvic: v.NVIC,
              bodyType: v.STYLE,
              transmissionType: v.TRANSMISSION,
              currentValue: +v.AVERAGE_PR,
              series: v.SERIES,
              drive: v.DRIVE
            };
          });
        })
      );
  }
}
